import { useState, useEffect, useRef } from "react";
import GpsFixedIcon from "@mui/icons-material/GpsFixed";
import RoomIcon from "@mui/icons-material/Room";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import AddIcon from "@mui/icons-material/Add";
import NearMeIcon from "@mui/icons-material/NearMe";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import DeleteIcon from "@mui/icons-material/Delete";
import WidgetsIcon from "@mui/icons-material/Widgets";
import CleaningServicesIcon from "@mui/icons-material/CleaningServices";
import MapIcon from "@mui/icons-material/Map";
import SearchIcon from "@mui/icons-material/Search";
import PolylineIcon from "@mui/icons-material/Polyline";
import EditIcon from "@mui/icons-material/Edit";
import PushPinIcon from "@mui/icons-material/PushPin";
import VisibilityIcon from "@mui/icons-material/Visibility";
import CircleIcon from "@mui/icons-material/Circle";
import PriorityHighIcon from "@mui/icons-material/PriorityHigh";

// openlayers
import Map from "ol/Map";
import View from "ol/View";
//import Geolocation from 'ol/Geolocation';
import { Point } from "ol/geom";
import { defaults, Modify, Select, Draw, Snap } from "ol/interaction";
import Feature from "ol/Feature";
import TileLayer from "ol/layer/Tile";
import VectorLayer from "ol/layer/Vector";
import VectorSource from "ol/source/Vector";
import Attribution from "ol/control/Attribution";
import { Icon, Style, Stroke, Fill } from "ol/style";
import XYZ from "ol/source/XYZ";
import { transform, fromLonLat } from "ol/proj";

import "../css/main.css";
import here from "../images/svg/arrow.svg";
import { user, emptys, mapsUrl, asianFormat } from "../data/main.js";

import {
  createMarker,
  newStyle,
  writeColor,
} from "./functions/createMarker.js";
import { strLang } from "../functions/strLang.js";
import { focusLayer } from "./functions/focusLayer.js";
import { checkAllDone } from "./functions/checkAllDone.js";

import { sendPostServices } from "../services/services.js";
import { getCurrentDate } from "../utilities/getCurrentDate.js";

import { createPDFMap } from "../functions/createPDF.js";
import { reOrder } from "./functions/reOrder.js";
import { providerTile } from "../data/tilesList.js";
import MiniButton from "../components/MiniButton.jsx";
import { colorsList } from "../data/colorsList.js";
import Compass from "./components/Compass.jsx";
import LimitButton from "./components/LimitButton.jsx";
import MapButton from "./components/MapButton.jsx";

import streetsImg from "../images/streets.png";
import satellitalImg from "../images/satellital.png";
import { updateUser } from "../services/territories.js";
import { currLang, isEditor } from "../functions/isEditor.js";
import { writeLimits } from "./functions/writeLimits.js";
import { screensList } from "../data/screensList.js";
import { groupsColors } from "../data/groupsColors.js";
import { avatarImages } from "../data/avatarsData.js";
import { eventsImages } from "../data/eventsData.js";
import { saveEventSeen } from "../functions/warningFunctions.js";

var mainView = false;
var mainAvatar = false;
const herePoint = new Point(fromLonLat([0, 0]));
var tile_layer = false;
var points_layer = false;
var events_layer = false;
var avatars_layer = false;
var area_layer = false;
var arrow_layer = false;
var areaInteraction = false;
var layersInteraction = false;
var drawInteraction = false;
var mobile = false;
var mainBoxList = false;
var allAddress = [];
var allPoints = [];
var allEvents = [];
var terId = false;
let activeOrientation = true;
let orientationCounter = false;
var dobleClickId = {
  id: false,
  tap: false,
};
var timeoutID = false;
const defRaster = {
  active: false,
  feature: false,
  section: false,
  map: false,
  id: false,
  point: false,
  index: false,
  type: false,
  origin: [0, 0],
  coords: [0, 0],
  nCoords: [0, 0],
  x: 0,
  y: 0,
  newX: false,
};
var tileError = false;
var keyRaster = { ...defRaster };

var areaRaster = false;
var infoRN = { active: false, grade: 0 };

user.avatar = localStorage.getItem("avatar");
user.name = localStorage.getItem("name");
user.id = localStorage.getItem("id");

const maxZoom = 18.33;

const mapButtonSize = 40;

let staticMaps = [];
let staticBoundary = {};

let PPColor = "";

const sectionDefault = {
  value: -1,
  label: strLang("allGroups"),
};

let staticMapType = "OSM";

export default function useTheMap(props) {
  const {
    mapData,
    openMainMsg,
    closeMainMsg,
    allMaps,
    openMap,
    allAddresses,
    userAvatar,
    syncData,
  } = props;
  const [open, setOpen] = useState({ status: false });
  const [open2, setOpen2] = useState({ status: false });
  const [viewList, setViewList] = useState({
    active: false,
    avatars: true,
    points: true,
    group: false,
    hasGroup: false,
    groupId: null,
    events: true,
    eventView: false,
  });
  const [title, setTitle] = useState("");
  const [dim, setDim] = useState({ main: [100, 100], list: [0, 0] });
  const [activeLook, setActiveLook] = useState(0);
  const [board, setBoard] = useState(0);
  const [pointId, setPointId] = useState({ id: -1, point: false });
  const [sectionId, setSectionId] = useState(sectionDefault);
  const [boundaryInfo, setBoundaryInfo] = useState({
    active: localStorage.getItem("activeBoundary") === "true",
    data: false,
    isEmpty: false,
  });
  const [pinAnimStep, setPinAnimStep] = useState(0);
  const [mapType, setMapType] = useState("");
  const [allSections, setAllSections] = useState([]);

  const [vmap, setvMap] = useState();
  const [address, setAddress] = useState({ list: [] });
  const stylesLimit = [
    new Style({
      stroke: new Stroke({ color: "rgba(0, 0, 255, 0.3)", width: 3 }),
      fill: new Fill({ color: "rgba(0, 0, 255, 0.05)" }),
    }),
  ];

  // pull refs
  const theMapBox = useRef();
  const mapElement = useRef();
  const leyendRef = useRef();
  const compassRef = useRef();
  const scrollMenu = useRef();

  const mapRef = useRef();
  mapRef.current = vmap;

  const moveHere = (coords) => {
    arrow_layer.setVisible(true);
    herePoint.setCoordinates(coords);
  };

  const saveLimit = async (isDelete = false, isNew = null) => {
    setOpen({ status: "loading" });
    try {
      let coords = "";
      if (!isDelete) {
        coords = (isNew ?? areaRaster.feature)
          .getGeometry()
          .getCoordinates()[0]
          .map(
            (e) => "[" + transform(e, "EPSG:3857", "EPSG:4326").toString() + "]"
          )
          .toString();
      }
      let payloadLimits = {
        type: "savelimit",
        code: !!isNew ? terId : areaRaster.id,
        color: null,
        coords,
      };
      // console.log(payloadLimits);
      const response = await sendPostServices(payloadLimits);
      // console.log(response);

      if (!!isNew) {
        activateEdition(false);
      }

      if (response && response.status) {
        if (!!isNew) {
          staticBoundary = { ...staticBoundary, isEmpty: false };
        }
        if (isDelete) {
          area_layer.getSource().removeFeature(areaRaster.feature);
          staticBoundary = { ...staticBoundary, isEmpty: true };
        }
        const mapIndex = staticMaps.findIndex(
          (e) => e.ID === Number(!!isNew ? terId : staticBoundary.data.id)
        );
        staticMaps[mapIndex].LIMITES = isDelete
          ? []
          : JSON.parse("[" + coords + "]");
        areaRaster = false;

        setBoundaryInfo({ ...staticBoundary });
        writeLimits({
          active: staticBoundary.active,
          area_layer,
          allMaps: staticMaps,
          terId,
          satColor: mapType === "Aerial",
        });
        closeMsg();
      } else {
        setOpen({ status: "netWorkError" });
      }
    } catch (error) {
      console.log("saveLimit error: ", error);
      setOpen({ status: "netWorkError" });
    }
  };

  const getCorrectSource = (data) => {
    if (emptys.includes(data)) {
      data = providerTile.OSM;
    }
    return new XYZ({
      url: data.url,
      attribution:
        "Powered by Esri. " +
        "Source: Esri, DigitalGlobe, GeoEye, Earthstar Geographics, CNES/Airbus DS, USDA, USGS, AeroGRID, IGN, and the GIS User Community",
      crossOrigin: "anonymous",
    });
  };

  const getLimitStatus = () => {
    const compare = [
      areaRaster.feature.getGeometry().getCoordinates()[0],
      areaRaster.coords[0],
    ];

    let hasChanged = false;
    if (compare[0].length !== compare[1].length) {
      hasChanged = true;
    } else {
      for (let a = 0; a < compare[0].length; a++) {
        if (
          compare[0][a][0] !== compare[1][a][0] ||
          compare[0][a][1] !== compare[1][a][1]
        ) {
          hasChanged = true;
          break;
        }
      }
    }
    return {
      new: hasChanged ? compare[0] : false,
      old: hasChanged ? compare[1] : false,
      hasChanged,
    };
  };

  useEffect(() => {
    //console.log("terId: ", terId);
    tile_layer = new TileLayer({
      source: getCorrectSource(providerTile[localStorage.getItem("tile")]),
    });

    points_layer = new VectorLayer({
      id: "points_group",
      source: new VectorSource(),
    });

    avatars_layer = new VectorLayer({
      id: "avatars_group",
      source: new VectorSource(),
    });

    events_layer = new VectorLayer({
      id: "events_group",
      source: new VectorSource(),
    });

    const boundarySource = new VectorSource({ features: [] });

    area_layer = new VectorLayer({
      id: "area_layer",
      source: boundarySource,
      style: stylesLimit,
    });

    const featArrow = new Feature({
      geometry: herePoint,
    });

    featArrow.setStyle(
      new Style({
        image: new Icon({
          anchor: [13, 55],
          anchorXUnits: "pixels",
          anchorYUnits: "pixels",
          src: here,
        }),
      })
    );

    arrow_layer = new VectorLayer({
      id: "arrow",
      zIndex: 1,
      visible: false,
      source: new VectorSource({ features: [featArrow] }),
    });

    mainView = new View({
      projection: "EPSG:3857",
      center: [0, 0],
      //center: fromLonLat([-79.52038, 9.00938]),
      zoom: 13,
      maxZoom,
    });

    // create map
    const initialMap = new Map({
      target: mapElement.current,
      layers: [
        tile_layer,
        area_layer,
        //hereVector,
        events_layer,
        points_layer,
        avatars_layer,
        arrow_layer,
      ],
      view: mainView,
      //controls: [],
      controls: defaults({ attribution: new Attribution() }),
      interactions: defaults({ doubleClickZoom: false }),
    });

    // geolocation = new Geolocation({
    //   tracking: true,
    //   trackingOptions: {
    //     enableHighAccuracy: true,
    //     maximumAge: 2000
    //   },
    //   projection: mainView.getProjection(),
    // });

    // update the HTML page when the position changes.
    /*geolocation.on('change', function () {
      el('accuracy').innerText = geolocation.getAccuracy() + ' [m]';
      el('altitude').innerText = geolocation.getAltitude() + ' [m]';
      el('altitudeAccuracy').innerText = geolocation.getAltitudeAccuracy() + ' [m]';
      el('heading').innerText = geolocation.getHeading() + ' [rad]';
      el('speed').innerText = geolocation.getSpeed() + ' [m/s]';
    });*/

    // geolocation.on('error', function (error) {
    //   console.log('error', error)
    // });

    /*const accuracyFeature = new Feature();
    geolocation.on('change:accuracyGeometry', function () {
      accuracyFeature.setGeometry(geolocation.getAccuracyGeometry());
    });*/

    mainAvatar = createMarker(
      {
        PUNTOS: user["id"],
        name: localStorage.getItem("name"),
        avatar: localStorage.getItem("avatar"),
      },
      "avatar",
      avatars_layer,
      -1,
      false,
      true
    );

    /*geolocation.on('change:position', function () {
      console.log(geolocation.getPosition())
      const coordinates = geolocation.getPosition();
      mainAvatar.setGeometry(coordinates ? new Point(coordinates) : null);
    });*/

    // geolocation.on('change:heading', function () {
    //   /*if (activeHeading>0 && !geolocation.getHeading()) {
    //     setActiveHeading(0)
    //   } else if (activeHeading===0 && geolocation.getHeading()) {
    //     setActiveHeading(1)
    //   }*/
    // });

    // set map onclick handler

    areaInteraction = new Select({ layers: [area_layer] });
    initialMap.addInteraction(areaInteraction);

    areaInteraction.setActive(false);

    if (isEditor) {
      layersInteraction = new Modify({
        features: areaInteraction.getFeatures(),
      });
      initialMap.addInteraction(layersInteraction);
      // Interacción de SNAP (magnético)
      const snapInteraction = new Snap({
        source: boundarySource,
        pixelTolerance: 10,
      });

      initialMap.addInteraction(snapInteraction);
      drawInteraction = new Draw({
        source: area_layer.getSource(),
        type: "Polygon",
        // finishCondition: (event) => {
        //   console.log("finish...", event);

        //   return true;
        // },
      });

      drawInteraction.on("drawend", (evt) => {
        setOpen({ status: "askSaveLimit", feature: evt.feature });
      });

      initialMap.addInteraction(drawInteraction);
      drawInteraction.setActive(false);
    }

    areaInteraction.on("select", function (event) {
      // console.log("selected");
      if (isEditor && areaRaster) {
        let limitData = getLimitStatus();

        if (limitData.hasChanged) {
          // console.log("start saving");
          setOpen({ status: "askSaveLimit" });
          return true;
        }
      }

      if (event.selected.length > 0) {
        staticBoundary = {
          ...staticBoundary,
          data: {
            id: event.selected[0].get("id").toString(),
            name: event.selected[0].get("name"),
          },
        };
        if (terId === "all" && event.selected[0].get("name") !== title) {
          setTitle(event.selected[0].get("name"));
        }
        writeAreaRaster(event.selected[0]);
      } else {
        staticBoundary = { ...staticBoundary, data: false };
        if (terId === "all") {
          setTitle("");
        }
        setTimeout(() => {
          areaRaster = false;
        }, 200);
        // console.log("erase");
      }
      setBoundaryInfo({ ...staticBoundary });
    });

    initialMap.on("dblclick", handleMapDblClick);
    initialMap.on("click", handleMapSingleClick);
    initialMap.on("moveend", setMap);
    // mainView.on("change:resolution", (event) => {
    //   console.log("zoom changed");
    // });

    mainView.on("change:rotation", () => {
      var grade = Math.round((mainView.getRotation() * 180) / Math.PI);
      compassRef.current.style.transform = "rotate(" + grade + "deg)";
    });

    // save map and vector layer references to state
    setvMap(initialMap);

    staticBoundary = boundaryInfo;

    const handleMessage = (event) => {
      if (infoRN.active && activeOrientation) {
        clearTimeout(orientationCounter);
        activeOrientation = false;
        try {
          if (typeof event.data === "string") {
            var tempData = JSON.parse(event.data);
            infoRN.grade = tempData.grade;

            compassRef.current.style.transform = `rotate(${infoRN.grade}deg)`;
            mainView.animate({
              rotation: (infoRN.grade * Math.PI) / 180,
              duration: 500,
            });

            orientationCounter = setTimeout(() => {
              activeOrientation = true;
            }, 1000);
          }
        } catch (error) {
          console.log("handleMessage error: ", error);
        }
      }
    };
    posOwnAvatar();

    const handleWheel = (event) => {
      event.preventDefault();
      scrollMenu.current.scrollLeft += event.deltaY;
    };

    window.addEventListener("resize", handleResize);
    document.addEventListener("resize", handleResize);
    window.addEventListener("message", handleMessage);
    document.addEventListener("message", handleMessage);
    scrollMenu.current.addEventListener("wheel", handleWheel);
    //window.addEventListener('deviceorientation', handleOrientation);

    return () => {
      window.removeEventListener("resize", handleResize);
      document.removeEventListener("resize", handleResize);
      window.removeEventListener("message", handleMessage);
      document.removeEventListener("message", handleMessage);
      if (scrollMenu.current) {
        scrollMenu.current.removeEventListener("wheel", handleWheel);
      }

      //window.removeEventListener('deviceorientation', handleOrientation)
    };
  }, []);

  const changeTile = (newTile, writeLines = true) => {
    if (!emptys.includes(providerTile[newTile])) {
      tile_layer.setSource(getCorrectSource(providerTile[newTile]));
      setMapType(newTile);
      staticMapType = newTile;
      if (writeLines) {
        writeLimits({
          active: staticBoundary.active,
          area_layer,
          allMaps: staticMaps,
          terId,
          satColor: newTile === "Aerial",
        });
      }
    }
  };

  useEffect(() => {
    if (["", "default"].includes(mapData.mapTile)) {
      changeTile(user.tile);
    }
  }, [user.tile]);

  // useEffect(() => {}, [props.heading]);

  useEffect(() => {
    staticMaps = allMaps;
  }, [allMaps]);

  useEffect(() => {
    // Detectar errores al cargar los tiles
    if (!tileError) {
      tile_layer.getSource().on("tileloaderror", function (event) {
        console.error("Error al cargar tile:", event);
        // const tile = event.tile;
        // Puedes obtener más información del tile o mostrar un mensaje al usuario
        tileError = true;
        setOpen({ status: "tileError" });
      });
    }

    if (mapData) {
      // console.log("data: ", mapData);
      terId = mapData.id;

      setTitle(mapData.title);
      allAddress = reOrder(mapData.address);
      allPoints = mapData.points;
      setAllSections(mapData.sections);
      setAddress({ list: [] });

      openBox2(mapData.renew ? false : mainBoxList);

      if (mapData.renew) {
        setSectionId(sectionDefault);
      }

      let polyCenter = mapData.renew
        ? writeLimits({
            active: boundaryInfo.active,
            area_layer,
            allMaps,
            terId,
            focus: true,
            satColor: mapData.fromMap && mapType === "Aerial",
          })
        : {};

      if (isEditor && polyCenter.data) {
        areaInteraction.setActive(boundaryInfo.active);
        layersInteraction.setActive(boundaryInfo.active);
      }

      writePoints({ renew: mapData.renew, data: polyCenter.data });

      setViewList({
        ...viewList,
        hasGroup: allPoints.some((e) => Number(e.SHAPE) > 0),
      });

      staticBoundary = boundaryInfo;
      setBoundaryInfo({ ...staticBoundary, isEmpty: polyCenter.isEmpty });

      let newTile = ["", "default"].includes(mapData.mapTile)
        ? localStorage.getItem("tile")
        : mapData.mapTile;
      if (mapData.renew && mapType !== newTile && !mapData.fromMap)
        changeTile(newTile, false);
    }
  }, [
    mapData.id,
    mapData.date,
    mapData.address,
    mapData.points,
    mapData.sections,
  ]);

  useEffect(() => {
    if (syncData.events) {
      allEvents = syncData.events.filter(
        (e) => e.TER === terId || e.EDATE.includes(getCurrentDate())
      );
      writeEvents();
    }
  }, [syncData.events]);

  useEffect(() => {
    avatars_layer
      .getSource()
      .getFeatures()
      .map((o) => {
        if (
          syncData.avatars.some(
            (v) => Number(v.ORD) === Number(o.get("id"))
          ) === false &&
          String(o.get("id")) !== String(localStorage.getItem("id"))
        ) {
          avatars_layer.getSource().removeFeature(o);
          //console.log('aaa', o.get('id'), localStorage.getItem('id'))
        } else {
          //console.log('bbb', o.get('id'), localStorage.getItem('id'))
        }
        return true;
      });

    syncData.avatars.forEach((o) => {
      if (o.ORD === Number(user.id) && o.SGROUP !== viewList.groupId) {
        setViewList({ ...viewList, groupId: o.SGROUP });
      }
      if (
        focusLayer(
          { id: o.ORD, lat: o.CX, lon: o.CY },
          "update",
          avatars_layer
        ) === false
      ) {
        createMarker(
          {
            PUNTOS: o.ORD,
            LAT: o.CX,
            LON: o.CY,
            name: o.NOMBRE,
            avatar: o.IMA,
          },
          "avatar",
          avatars_layer
        );
      }
    });
  }, [syncData.avatars]);

  useEffect(() => {
    posOwnAvatar();
  }, [props.mainCoords]);

  const writePoints = ({ renew, data, active = false, section = null }) => {
    if (section) {
      setSectionId({ ...section });
    }
    const tempSection = section ?? sectionId;

    points_layer.getSource().clear();
    allPoints.forEach((o) => {
      o.ADDRS = mapData.address.filter(
        (v) => Number(v.PUNTO) === Number(o.PUNTOS)
      ).length;
      if (Number(o.SEC) === 0) {
        createMarker(o, "flag", points_layer);
      } else {
        if (
          (!active ||
            !viewList.hasGroup ||
            (viewList.hasGroup &&
              active &&
              viewList.groupId &&
              o.SHAPE === viewList.groupId)) &&
          (tempSection.value === -1 ||
            o.SECTION === allSections[tempSection.value]?.ID)
        ) {
          o.STATUS = checkAllDone(o.PUNTOS, allAddress, o.COLOR);
          createMarker(o, "point", points_layer, false, false);

          if (o.LAT2 && o.LON2) {
            createMarker(o, "pin", points_layer);
          }
        }
      }

      if (renew) {
        if (mapData.centerpoint === "reload" && localStorage.getItem("zoom")) {
          mapRef.current
            .getView()
            .setCenter(JSON.parse(localStorage.getItem("coords")));
          //mapRef.current.getView().setRotation(localStorage.getItem('angle'))
          mapRef.current.getView().setZoom(localStorage.getItem("zoom"));
        } else if (Number(mapData.centerpoint) === Number(o.PUNTOS)) {
          mapRef.current
            .getView()
            .setCenter(fromLonLat([o.LAT, o.LON]), "EPSG:32643", "EPSG:32643");
          mapRef.current.getView().setZoom(19);
          moveHere(fromLonLat([o.LAT, o.LON]));
        } else if (area_layer.getSource().getFeatures().length === 0) {
          mapRef.current.getView().fit(points_layer.getSource().getExtent(), {
            padding: [50, 50, 50, 50],
          });
        } else if (data) {
          mapRef.current.getView().fit(data.getExtent(), {
            duration: 1000,
            padding: [10, 10, 10, 10],
          });
        }
      }
    });
    if (mainBoxList && section) {
      openBox2("all", tempSection.value);
    }
  };

  const writeEvents = () => {
    setViewList({ ...viewList, eventView: allEvents.length > 0 });
    events_layer.getSource().clear();
    allEvents.forEach((o) => {
      createMarker(
        {
          PUNTOS: o.ID,
          LAT: o.LAT,
          LON: o.LON,
          name: o.NAME,
          type: o.ETYPE,
        },
        "mapEvent",
        events_layer
      );
    });
  };

  const openFromBoundary = () => {
    startMap({
      id: boundaryInfo.data.id,
      name: boundaryInfo.data.name,
    });
    staticBoundary = { ...staticBoundary, data: false };
    setBoundaryInfo({ ...staticBoundary });
    // openMainMsg(false, {
    //   title: boundaryInfo.data.name,
    //   buttons: [
    //     {
    //       label: strLang("open"),
    //       func: () =>
    //         startMap({
    //           id: boundaryInfo.data.id,
    //           name: boundaryInfo.data.name,
    //         }),
    //     },
    //   ],
    // });
  };

  const posOwnAvatar = () => {
    try {
      if (props.mainCoords?.longitude && props.mainCoords?.latitude) {
        mainAvatar.setGeometry(
          new Point(
            fromLonLat([props.mainCoords.longitude, props.mainCoords.latitude])
          )
        );

        if (activeLook > 1) {
          goTo(
            fromLonLat([props.mainCoords.longitude, props.mainCoords.latitude])
          );
        }

        //activeHeading===2 && mainView.animate({rotation: geolocation.getHeading(), duration: 500})

        //var fromLatLon = fromLonLat([props.mainCoords.longitude, props.mainCoords.latitude])
        //alert(props.mainCoords.heading)
        /*if (focusLayer({id: localStorage.getItem('id'), lat: props.mainCoords.longitude, lon:props.mainCoords.latitude}, 'update', avatars_layer) === false) {
        createMarker({
          PUNTOS: localStorage.getItem('id'),
          LAT: props.mainCoords.longitude,
          LON: props.mainCoords.latitude,
          name: localStorage.getItem('name'),
          avatar: localStorage.getItem('avatar')
        }, 'avatar', avatars_layer)
      }*/

        //activeLook===3 && mainView.animate({rotation: props.mainCoords.heading, duration: 500})
        //console.log("act" + activeLook);
        if (activeLook === 0) {
          setActiveLook(1);
          infoRN.active = false;
        }
      } else {
        //setActiveLook(0);
        //revokeAccess();
      }
    } catch (error) {
      console.log("posOwnAvatar error: ", error);
    }
  };

  const handleResize = () => {
    mobile = theMapBox.current.clientWidth < theMapBox.current.clientHeight;

    let wh =
      mobile && leyendRef.current.style.height === "100%"
        ? "width"
        : leyendRef.current.style.width === "100%"
        ? "height"
        : false;

    if (wh) {
      openBox2(leyendRef.current.style[wh] === "0%" ? false : "keep");
    }
  };

  const setMap = () => {
    if (
      mapRef.current.getView().getZoom() != 13 &&
      mapRef.current
        .getView()
        .getCenter()
        .reduce((a, b) => a - b) != 0
    ) {
      localStorage.setItem("zoom", mapRef.current.getView().getZoom());
      localStorage.setItem(
        "coords",
        JSON.stringify(mapRef.current.getView().getCenter())
      );
      //localStorage.setItem('angle', mapRef.current.getView().getRotation())
    }
    //setActiveLook(1)
    //if (activeLook>1) {setActiveLook(1)}
  };

  const writeRaster = (_feat) => {
    keyRaster.feature = _feat;
    keyRaster.id = _feat.get("id");
    keyRaster.point = _feat.get("point");
    keyRaster.section = _feat.get("section");
    keyRaster.map = _feat.get("map");
    keyRaster.index = allPoints.findIndex(
      (o) => Number(o.PUNTOS) === Number(_feat.get("id"))
    );
    keyRaster.type = _feat.get("group");
    keyRaster.coords = keyRaster.origin = _feat.getGeometry().getCoordinates();
  };

  const writeAreaRaster = (_feat) => {
    areaRaster = {
      id: _feat.get("id"),
      color: _feat.get("color"),
      newColor: false,
      feature: _feat,
      coords: _feat.getGeometry().getCoordinates(),
    };
  };

  const focusPoint = (temp_feature) => {
    if (temp_feature) {
      closeGPS();
      writeRaster(temp_feature);
      goTo(temp_feature.getGeometry().getCoordinates(), true);

      switch (temp_feature.get("group")) {
        case "flag":
        case "point":
          openBox2(temp_feature.get("id"));
          break;
        case "mapEvent":
          const tempEvent = allEvents.filter(
            (e) => e.ID === temp_feature.get("id")
          );
          if (isEditor) {
            openNewEventModal({
              ...tempEvent[0],
              coordinate: [tempEvent[0].LAT, tempEvent[0].LON],
            });
          } else {
            openMainMsg(false, {
              type: "event",
              eventId: tempEvent[0].ETYPE,
              title: emptys.includes(tempEvent[0].NAME)
                ? strLang(eventsImages["v" + tempEvent[0].ETYPE].title)
                : tempEvent[0].NAME,
              intro:
                tempEvent[0].ETYPE === 1 && tempEvent[0].NAME !== ""
                  ? null
                  : tempEvent[0].OBSER !== ""
                  ? tempEvent[0].EUSER + strLang("says")
                  : strLang("saidBy") + tempEvent[0].EUSER,
              label: tempEvent[0].OBSER,
              buttons: [
                {
                  label: strLang("go"),
                  func: () => setOpen({ status: "goRoute" }),
                },
                Number(tempEvent[0].USERID) === Number(user.id) && {
                  label: strLang("edit"),
                  color: colorsList.green,
                  func: () => {
                    closeMainMsg();
                    openNewEventModal({
                      ...tempEvent[0],
                      coordinate: [tempEvent[0].LAT, tempEvent[0].LON],
                    });
                  },
                },
              ],
            });
          }
          break;
        default:
          break;
      }
    }
  };

  const handleMapSingleClick = (event) => {
    const temp_feature = mapRef.current.forEachFeatureAtPixel(
      event.pixel,
      (feature) => feature
    );
    if (!isEditor && temp_feature) {
      const originData = {
        id: temp_feature.get("id"),
        group: temp_feature.get("group"),
        newClick: temp_feature.get("id") !== staticBoundary.data?.id,
        another: temp_feature.get("group") === "boundary",
      };
      if (
        originData.newClick &&
        (originData.group === "boundary" ||
          (originData.group !== "boundary" && staticBoundary.data))
      ) {
        staticBoundary = {
          active: staticBoundary.active,
          data: originData.another
            ? { id: originData.id.toString(), name: temp_feature.get("name") }
            : false,
          isEmpty: staticBoundary.isEmpty,
        };
        setBoundaryInfo({ ...staticBoundary });

        writeLimits({
          active: true,
          area_layer,
          allMaps: staticMaps,
          terId,
          selected: originData.another ? originData.id : false,
          satColor: staticMapType === "Aerial",
        });
      }
    }
  };

  // map click handler
  const handleMapDblClick = (event) => {
    if (!staticBoundary.createActive) {
      const temp_feature = mapRef.current.forEachFeatureAtPixel(
        event.pixel,
        (feature) => feature
      );

      if (
        temp_feature &&
        ["point", "flag", "mapEvent"].includes(temp_feature.get("group"))
      ) {
        focusPoint(temp_feature);
      } else {
        closeGPS();

        setTimeout(
          () => openNewEventModal({ coordinate: event.coordinate }),
          250
        );
      }

      /*
    const clickedCoord = mapRef.current.getCoordinateFromPixel(event.pixel);
    //alert(clickedCoord)
    // transform coord to EPSG 4326 standard Lat Long
    const transormedCoord = transform(clickedCoord, 'EPSG:3857', 'EPSG:4326')
    //vmap.getView().setCenter(clickedCoord, 'EPSG:32643', 'EPSG:32643');
    // set React state
    setSelectedCoord( transormedCoord )
    //mapRef.current.getView().setCenter(fromLonLat(transormedCoord), 'EPSG:32643', 'EPSG:32643');
    createMarker({LAT:transormedCoord[0], LON:transormedCoord[1]}, 'flag')
    */
    }
  };

  const goTo = (value, _arrow) => {
    if (!value) {
      return value;
    }
    _arrow && moveHere(value);
    mainView.animate({ center: value, duration: 500 });
  };

  const openWindow = (index, data) => {
    if (Number(localStorage.getItem("rol") > 0)) {
      setOpen({
        status: "editorWindow",
        index,
        data,
        name: data.NOM,
        obser: data.OBSER,
        notes: data.NOTAS,
      });
    } else {
      setOpen({ status: "userWindow", index, data, notes: data.NOTAS });
    }
  };

  const updateCheck = async (type, o) => {
    setOpen({ status: "loading" });
    try {
      let tempAddr = address.list;

      if (type === "EST") {
        if (Number(o.data.EST) === Number(o.value)) {
          o.value = 0;
        }
        tempAddr[o.index][type] = -1;
        setAddress({ list: tempAddr });
      }

      var tvar = { type, date: getCurrentDate(true) };
      switch (type) {
        case "ADDR":
          o.index = allAddress.filter(
            (o) => Number(o.PUNTO) === pointId.id
          ).length;
          tvar = {
            ...tvar,
            code: keyRaster.feature.get("id"),
            number: keyRaster.feature.get("point"),
            order: o.index,
            name: o.name,
            obs: o.obs,
            map: keyRaster.feature.get("map"),
          };
          break;
        case "DELETE":
          tvar = {
            ...tvar,
            code: o.data.ID,
            point: o.data.PUNTO,
            number: o.data.PP,
            map: terId,
          };
          break;
        case "UPDATEPOINT":
          tvar = {
            ...tvar,
            group: keyRaster.type,
            code: o.code,
            number_old: o.number_old,
            number_new: o.number_new,
            map_old: o.map_old,
            map_new: o.map_new,
            updateNumber: !(
              o.number_old === o.number_new && o.map_old === o.map_new
            ),
            color: o.color,
            section: o.section,
          };
          break;
        case "CLEAN":
          tvar = {
            ...tvar,
            map: terId,
          };
          break;
        case "ADDSECTION":
          tvar = { ...o, ...tvar };
          break;
        case "SECTION":
          tvar = {
            ...tvar,
            code: keyRaster.id,
            section: o.section,
            map: keyRaster.feature.get("map"),
          };
          break;
        case "UPDATE":
          tvar = {
            ...tvar,
            code: o.id,
            name: o.name,
            obs: o.obs,
            notes: o.notes,
            map: terId,
          };
          break;
        case "pin":
          tvar = {
            ...tvar,
            code:
              typeof o.code === "string"
                ? o.code.replace("pin_", "np_")
                : o.code,
            type: "np",
            lat: o.lat,
            lon: o.lon,
            delete: o.delete,
            map: keyRaster.feature.get("map"),
          };
          // console.log("tvar pin", tvar);
          break;
        // case "flag":
        //   tvar = {
        //     ...tvar,
        //     lat: o.lat,
        //     lon: o.lon,
        //     obs: o.obs,
        //     map: o.map,
        //   };
        //   break;
        case "saveEvent":
        case "deleteEvent":
          tvar = {
            ...tvar,
            ...o,
          };
          break;
        default:
          tvar = {
            ...tvar,
            code: o.data.ID,
            value: o.value,
            map: terId,
            user: localStorage.getItem("name"),
            rol: localStorage.getItem("rol"),
          };
          break;
      }

      // console.log("tvar", tvar);
      const response = await sendPostServices(tvar);

      // console.log("response", response);
      if (response.status) {
        user.date = response.date;
        switch (type) {
          case "ADDR":
            allAddress.push({
              EST: 0,
              ID: response.code,
              NOM: o.name,
              NOTAS: "",
              OBSER: o.obs,
              PUNTO: keyRaster.feature.get("id"),
              PP: keyRaster.feature.get("point"),
            });
            allAddress = reOrder(allAddress);

            tempAddr.push({
              EST: 0,
              ID: response.code,
              NOM: o.name,
              NOTAS: "",
              OBSER: o.obs,
              PUNTO: keyRaster.feature.get("id"),
              SEC: keyRaster.feature.get("point"),
            });
            break;
          case "DELETE":
            var thePoint = tempAddr[o.index].PUNTO;
            var theNumber = tempAddr[o.index].PP;
            var theId = tempAddr[o.index].ID;
            tempAddr.splice(o.index, 1);
            allAddress = allAddress.filter((o) => o.ID != theId);
            let _feat0 = getFeat(thePoint, points_layer);
            // console.log("DELETE", response);
            if (response.deletedpoint) {
              let _typefeat = _feat0.get("group");
              if (_typefeat === "point") {
                let _flag = getFeat("pin_" + _feat0.get("id"), points_layer);
                if (_flag) {
                  points_layer.getSource().removeFeature(_flag);
                }
              }

              points_layer.getSource().removeFeature(_feat0);
              if (_typefeat === "point") {
                moveNumbers(
                  allPoints.findIndex((p) => p.SEC == theNumber),
                  -1
                );
              }
              allPoints = allPoints.filter((o) => o.PUNTOS != thePoint);
              if (pointId.id != -1) {
                openBox2(false);
              }
            } else if (_feat0.get("group") === "point") {
              _feat0.setStyle(
                newStyle(
                  theNumber,
                  checkAllDone(thePoint, tempAddr, _feat0.get("color")[0])
                )
              );
            }
            allPoints.sort((a, b) => (a.SEC > b.SEC ? 1 : -1));
            allAddress = reOrder(allAddress);
            break;
          case "UPDATEPOINT":
            keyRaster.feature.set("color", writeColor(o.color));
            keyRaster.feature.setStyle(
              newStyle(
                keyRaster.point,
                checkAllDone(
                  keyRaster.id,
                  allAddress,
                  o.color === "" ? false : o.color
                )
              )
            );
            keyRaster.feature.set("section", Number(o.section));
            for (let z = 0; z < allPoints.length; z++) {
              if (allPoints[z].PUNTOS == keyRaster.id) {
                allPoints[z].SECTION = Number(o.section);
                break;
              }
            }

            if (!(o.number_old === o.number_new && o.map_old === o.map_new)) {
              let _featExists = true;
              if (o.map_old !== o.map_new && terId > 0) {
                points_layer.getSource().removeFeature(keyRaster.feature);
                let _pin = getFeat("pin_" + keyRaster.id, points_layer);
                if (_pin) {
                  points_layer.getSource().removeFeature(_pin);
                }
                allAddress = allAddress.filter((p) => p.PUNTO != keyRaster.id);
                allPoints = allPoints.filter((p) => p.PUNTOS != keyRaster.id);
                _featExists = false;
              }

              if ((terId === "all" || o.map_old === o.map_new) && _featExists) {
                keyRaster.feature.set("point", 0);
                keyRaster.feature.set("map", 0);
                allPoints[keyRaster.index].SEC = 0;
                allPoints[keyRaster.index].TER = 0;

                keyRaster.point = 0;
                keyRaster.map = 0;

                allPoints[keyRaster.index].STATUS = checkAllDone(
                  keyRaster.id,
                  allAddress
                );
                allPoints[keyRaster.index].SEC = o.number_new;
                allPoints[keyRaster.index].TER = o.map_new;
                updateAddList(keyRaster.id, o.number_new);

                if (keyRaster.type === "flag") {
                  points_layer.getSource().removeFeature(keyRaster.feature);
                  createMarker(
                    allPoints[keyRaster.index],
                    "point",
                    points_layer,
                    false,
                    false
                  );
                } else {
                  keyRaster.feature.set("point", o.number_new);
                  keyRaster.feature.set("map", o.map_new);
                  keyRaster.feature.setStyle(
                    newStyle(o.number_new, allPoints[keyRaster.index].STATUS)
                  );
                }
                arrangeNumbers(o.number_new - 1, o.map_new, 1, response.list);
                allPoints.sort((a, b) => (a.SEC > b.SEC ? 1 : -1));
                allAddress = reOrder(allAddress);
              }
              // clearRaster();
            }
            openBox2(o.code);
            break;
          case "CLEAN":
            allAddress.map((o) => {
              return {
                ...o,
                EST: 0,
              };
            });
            points_layer
              .getSource()
              .getFeatures()
              .forEach((c) => {
                if (c.get("group") === "point") {
                  let thecolor = checkAllDone(
                    c.get("id"),
                    allAddress,
                    c.get("color")[0]
                  );
                  c.setStyle(newStyle(c.get("point"), thecolor));
                }
              });
            if (pointId.id === -1) {
              openBox2("all");
            }
            break;
          case "ADDSECTION":
            let tempAllSections = allSections;
            if (o.kill) {
              tempAllSections.splice(o.index, 1);
              writePoints({ active: viewList.group, section: sectionDefault });
              points_layer
                .getSource()
                .getFeatures()
                .forEach((c) => {
                  if (Number(c.get("section")) === o.id) {
                    c.set("section", 0);
                    for (let z = 0; z < allPoints.length; z++) {
                      if (allPoints[z].SECTION === o.id) {
                        allPoints[z].SECTION = 0;
                      }
                    }
                  }
                });
            } else {
              if (o.id) {
                tempAllSections[o.index] = {
                  ...tempAllSections[o.index],
                  NAME: o.name,
                };
                setSectionId({ value: o.index, label: o.name });
              } else {
                tempAllSections.push({
                  ID: response.code,
                  NAME: o.name,
                  ORD: response.ord,
                  TER: o.map,
                });
              }
            }

            setAllSections([...tempAllSections]);
            break;
          case "SECTION":
            keyRaster.feature.set("section", Number(o.section));
            for (let z = 0; z < allPoints.length; z++) {
              if (allPoints[z].PUNTOS == keyRaster.id) {
                allPoints[z].SECTION = Number(o.section);
                break;
              }
            }
            break;
          case "UPDATE":
            let idx = allAddress.findIndex((p) => p.ID == o.id);
            allAddress[idx].NOM = tempAddr[o.index].NOM = o.name;
            allAddress[idx].OBSER = tempAddr[o.index].OBSER = o.obs;
            allAddress[idx].NOTAS = tempAddr[o.index].NOTAS = o.notes;
            break;
          case "pin":
            if (response.code) {
              user.date = response.date;
              let _feat = false;
              if (keyRaster.nCoords[0] === "del") {
                points_layer
                  .getSource()
                  .removeFeature(
                    getFeat(keyRaster.feature.get("id"), points_layer)
                  );
                _feat = keyRaster.feature;

                let idx = allPoints.findIndex(
                  (p) =>
                    Number(p.PUNTOS) ===
                    Number(keyRaster.feature.get("id").split("_")[1])
                );

                if (idx > -1) {
                  allPoints[idx].LAT2 = null;
                  allPoints[idx].LON2 = null;
                }
              } else if (o.delete) {
                let _pin = getFeat(
                  "pin_" + keyRaster.feature.get("id"),
                  points_layer
                );
                if (_pin) {
                  //console.log(keyRaster["feature"].get("id"));
                  let idx = allPoints.findIndex(
                    (p) => p.PUNTOS === Number(keyRaster.feature.get("id"))
                  );
                  //console.log(idx);
                  allPoints[idx].LAT2 = null;
                  allPoints[idx].LON2 = null;
                  points_layer.getSource().removeFeature(_pin);
                }
                keyRaster.feature
                  .getGeometry()
                  .setCoordinates(keyRaster.coords);
                mapRef.current.getView().setCenter(keyRaster.coords);
                _feat = keyRaster.feature;
              }
              if (_feat) {
                writeRaster(_feat);
                setPointId({
                  id: Number(_feat.get("id")),
                  point: Number(_feat.get("point")),
                });
              }
            }
            break;
          // case "flag":
          //   if (response.code) {
          //     user.date = response.date;
          //     createMarker(
          //       { ...response.point[0] },
          //       "flag",
          //       points_layer,
          //       o.coords
          //     );
          //     response.address.map((o) => allAddress.push(o));
          //     response.point.map((o) => allPoints.push(o));
          //     allPoints.sort((a, b) => (a.SEC > b.SEC ? 1 : -1));
          //     allAddress = reOrder(allAddress);
          //   }
          //   break;
          case "saveEvent":
            if (response.code) {
              if (o.cat === 0) {
                user.date = response.date;
                createMarker(
                  { ...response.point[0] },
                  "flag",
                  points_layer,
                  o.coords
                );
                response.address.map((o) => allAddress.push(o));
                response.point.map((o) => allPoints.push(o));
                allPoints.sort((a, b) => (a.SEC > b.SEC ? 1 : -1));
                allAddress = reOrder(allAddress);
              } else {
                let newData = {
                  ID: response.code,
                  NAME: o.name,
                  OBSER: o.obs,
                  TER: o.ter,
                  LAT: o.lat,
                  LON: o.lon,
                  EDATE: o.date,
                  ETYPE: o.cat,
                  EUSER: o.userName,
                  USERID: o.userId,
                };
                if (o.code) {
                  let eventIndex = allEvents.findIndex((e) => e.ID === o.code);
                  if (eventIndex > -1) {
                    allEvents[eventIndex] = newData;
                  }
                } else {
                  allEvents.push(newData);
                }
                saveEventSeen({
                  id: newData.ID,
                  date: newData.EDATE,
                });
                writeEvents();
              }
            }
            break;
          case "deleteEvent":
            let eventIndex = allEvents.findIndex((e) => e.ID === o.id);
            if (eventIndex > -1) {
              allEvents.splice(eventIndex, 1);
              writeEvents();
            }
            break;
          default:
            tempAddr[o.index][type] = response[type][0][type];
            let a_feat = getFeat(tempAddr[o.index].PUNTO, points_layer);
            if (a_feat && a_feat.get("group") === "point") {
              a_feat.setStyle(
                newStyle(
                  tempAddr[o.index].PP,
                  checkAllDone(
                    tempAddr[o.index].PUNTO,
                    tempAddr,
                    a_feat.get("color")[0]
                  ),
                  a_feat.get("shape")
                )
              );
            }
            break;
        }

        if (!["ADDSECTION"].includes(type)) {
          setAddress({ list: [...tempAddr] });
          props.updateMap(terId, allPoints, allAddress);
        }

        closeMsg();
      } else if (response.netWorkError) {
        setOpen({ status: "netWorkError" });
      } else {
        setOpen({ status: "updateError" });
      }
    } catch (error) {
      console.log("updateCheck error: ", error);
      setOpen({ status: "updateError" });
    }
  };

  const openNewEventModal = (data) => {
    const { coordinate, ETYPE, ID, NAME, OBSER } = data;
    setOpen({
      status: "newEvent",
      code: ID,
      title: strLang(ETYPE ? eventsImages["v" + ETYPE].title : "flag"),
      cat: ETYPE ?? 0,
      details: strLang(
        ETYPE ? eventsImages["v" + ETYPE].details : "flagDetails"
      ),
      addressList: [],
      mapsList:
        terId === "all"
          ? [
              {
                value: 0,
                label: strLang("selectTerritory"),
              },
              ...sortMaps(),
            ]
          : null,
      map:
        terId === "all"
          ? {
              value: 0,
              label: strLang("selectTerritory"),
            }
          : {
              value: terId,
              label: staticMaps.filter((e) => e.ID === Number(terId))[0].NOM,
            },
      name: NAME ?? "",
      text: OBSER ?? "",
      coords: [...coordinate],
    });
  };

  const arrangeNumbers = (_point, _map, _increase, realList) => {
    var tempIndex;
    realList.forEach((h) => {
      tempIndex = allPoints.findIndex((p) => p.PUNTOS == h.PUNTOS);
      if (tempIndex > -1) {
        allPoints[tempIndex].SEC = Number(h.SEC);
        updateAddList(allPoints[tempIndex].PUNTOS, allPoints[tempIndex].SEC);
        let _feat = getFeat(allPoints[tempIndex].PUNTOS, points_layer);
        if (_feat) {
          _feat.set("point", allPoints[tempIndex].SEC);
          _feat.setStyle(
            newStyle(
              allPoints[tempIndex].SEC,
              checkAllDone(
                allPoints[tempIndex].PUNTOS,
                allAddress,
                _feat.get("color")[0]
              )
            )
          );
        }

        _feat = getFeat("pin_" + allPoints[tempIndex].PUNTOS, points_layer);
        if (_feat) {
          points_layer.getSource().removeFeature(_feat);
          createMarker(allPoints[tempIndex], "pin", points_layer);
        }
      }
    });

    /*allPoints.map((o, index) => {
      if (
        allPoints[index].SEC > _point &&
        Number(allPoints[index].TER) === Number(_map)
      ) {
        allPoints[index].SEC = Number(allPoints[index].SEC) + _increase;
        updateAddList(allPoints[index].PUNTOS, allPoints[index].SEC);
        let _feat = getFeat(allPoints[index].PUNTOS, points_layer);
        if (_feat) {
          _feat.set("point", allPoints[index].SEC);
          _feat.setStyle(
            newStyle(
              allPoints[index].SEC,
              checkAllDone(
                allPoints[index].PUNTOS,
                allAddress,
                _feat.get("color")[0]
              )
            )
          );
        }

        _feat = getFeat("np_" + allPoints[index].PUNTOS, points_layer);
        if (_feat) {
          points_layer.getSource().removeFeature(_feat);
          createMarker(allPoints[index], "np", points_layer);
        }
      }
      return true;
    });*/
    return true;
  };

  const startMap = (data) => {
    setOpen("loading");
    openMap({
      id: data.id,
      name: data.name,
      point: data.point ?? false,
      fromMap: true,
    });
    updateUser(data.id);
    closeMainMsg();
  };

  const getEventsList = () => {
    let tempEvents = [];
    if (open?.status === "eventsList") {
      tempEvents = allEvents.map((o, index) => {
        return {
          bgColor: index % 2 === 0 ? colorsList.lightGrey : colorsList.white,
          onClick: () => {
            closeMsg();
            setTimeout(() => focusPoint(getFeat(o.ID, events_layer)), 250);
          },
          data: [
            { src: eventsImages["v" + o.ETYPE].svg },
            o.NAME !== "" ? o.NAME : strLang(eventsImages["v" + o.ETYPE].title),
          ],
        };
      });
    }
    return tempEvents;
  };

  const updateAddList = (_id, _value) => {
    allAddress.forEach((h, index) => {
      if (h.PUNTO == _id) {
        allAddress[index].PP = _value;
      }
    });
    return true;
  };

  const getTerList = () => {
    let tempTabla = [];
    if (open?.status === "territoriesList") {
      let tempMaps =
        open.search === ""
          ? [...allMaps]
          : [
              ...allMaps.filter((e) =>
                e.NOM.toLowerCase().includes(open.search.toLowerCase().trim())
              ),
            ];
      tempTabla = tempMaps
        .sort((a, b) => (a.NOM < b.NOM ? -1 : a.NOM > b.NOM ? 1 : 0))
        .map((o, index) => {
          return {
            bgColor: index % 2 === 0 ? colorsList.lightGrey : colorsList.white,
            onClick: () =>
              openMainMsg(false, {
                title: o.NOM,
                buttons: [
                  {
                    label: strLang("open"),
                    func: () => startMap({ id: o.ID, name: o.NOM }),
                  },
                ],
              }),
            data: [o.NOM],
          };
        });
    }
    return tempTabla;
  };

  const getAddressList = () => {
    let tempTabla = [];
    if (open?.status === "addressesList" && open.search.trim() !== "") {
      let tempMaps = [
        ...allAddresses.filter((e) =>
          e.NOM.toLowerCase().includes(open.search.trim().toLowerCase())
        ),
      ];
      tempTabla = tempMaps
        .sort((a, b) => (a.NOM < b.NOM ? -1 : a.NOM > b.NOM ? 1 : 0))
        .map((o, index) => {
          return {
            bgColor: index % 2 === 0 ? colorsList.lightGrey : colorsList.white,
            onClick: () => {
              if (o.IDTER === Number(mapData.id)) {
                focusPoint(getFeat(o.PUNTO, points_layer));
                closeMsg();
              } else {
                openMainMsg(false, {
                  title: strLang("openThisPoint"),
                  label: o.NOM,
                  buttons: [
                    {
                      label: strLang("open"),
                      func: () =>
                        startMap({ id: o.IDTER, name: o.NTER, point: o.PUNTO }),
                    },
                  ],
                });
              }
            },
            data: [o.SEC, `${o.NOM}`, `${o.NTER}`],
          };
        });
    }
    return tempTabla;
  };

  const moveNumbers = (_number, _value) => {
    _number = Number(_number);
    if (_number > -1) {
      for (var w = _number; w < allPoints.length; w++) {
        if (
          allPoints[w].PUNTOS !== keyRaster.id &&
          keyRaster.map === allPoints[w].TER
        ) {
          allPoints[w].SEC += _value;

          updateAddList(allPoints[w].PUNTOS, allPoints[w].SEC);

          let _pin = getFeat(allPoints[w].PUNTOS, points_layer);
          if (_pin) {
            _pin.set("point", allPoints[w].SEC);
            _pin.setStyle(
              newStyle(
                allPoints[w].SEC,
                checkAllDone(
                  allPoints[w].PUNTOS,
                  allAddress,
                  _pin.get("color")[0]
                )
              )
            );
          }

          _pin = getFeat("pin_" + allPoints[w].PUNTOS, points_layer);
          if (_pin) {
            points_layer.getSource().removeFeature(_pin);
            createMarker(allPoints[w], "pin", points_layer);
          }
        }
      }
    }
    // points_layer.getSource().getFeatures().forEach(async(c) => {
    //   if (c.get('group')==='point' && Number(c.get('point'))>_axis && c.get('id')!=keyRaster.id) {

    //     let cvalue = c.get('point')+_value

    //     updateAddList(c.get('id'), cvalue, true)

    //     c.set('point', cvalue)
    //     c.setStyle(newStyle(cvalue, checkAllDone(c.get('id'), allAddress, c.get('color'))))

    //     let _np = getFeat('np_'+c.get('id'))
    //     if (_np) {
    //       points_layer.getSource().removeFeature(_np)
    //       console.log('aaaaS')
    //       console.log(allPoints[_index])
    //       createMarker(allPoints[_index], 'np', points_layer)
    //     }

    //   }
    // })

    return true;
  };

  const updateCategory = ({ id, title, details }) => {
    setOpen({
      ...open,
      cat: id,
      title: strLang(title),
      details: strLang(details),
    });
  };

  const openBox2 = async (data, index = sectionId.value) => {
    mainBoxList = data;
    let tDim = false;
    mobile = theMapBox?.current?.clientWidth < theMapBox?.current?.clientHeight;
    if (data) {
      switch (data) {
        case "all":
          setPointId({ id: -1, point: false });
          if (mapData) {
            let oneSection =
              index > -1
                ? [...allPoints]
                    .filter((e) => e.SECTION === allSections[index]?.ID)
                    .map((d) => d.PUNTOS)
                : [];
            allAddress.length > 0 &&
              setAddress({
                list:
                  index > -1
                    ? allAddress.filter((e) => oneSection.includes(e.PUNTO))
                    : allAddress,
              });
          }
          break;
        case "keep":
          break;
        default:
          setPointId({
            id: getFeat("pin_" + keyRaster.feature.get("id"), points_layer)
              ? "delete"
              : data,
            point: keyRaster.point,
          });

          PPColor = keyRaster.feature.get("color")
            ? keyRaster.feature.get("color")[0]
            : "";
          setAddress({
            list: allAddress.filter((o) => Number(o.PUNTO) === Number(data)),
          });
          break;
      }

      tDim = mobile
        ? { main: [100, 70], list: [100, 30] }
        : { main: [70, 100], list: [30, 100] };
    } else {
      if (mapData) {
        mapData.address.length > 0 && setAddress({ list: [] });
      }
      tDim = mobile
        ? { main: [100, 100], list: [100, 0] }
        : { main: [100, 100], list: [0, 100] };
    }
    setDim(tDim);
  };

  const closeGPS = () => {
    setActiveLook(1);
    infoRN.active = false;
  };

  const handleClickAddr = (index, firstTap, secondTap) => {
    if (dobleClickId.id !== index) {
      if (firstTap) {
        firstTap();
      }
      dobleClickId.id = index;
      if (timeoutID) {
        clearTimeout(timeoutID);
      }
      timeoutID = setTimeout(() => {
        dobleClickId.id = false;
      }, 250);
    } else {
      secondTap();
      dobleClickId.id = false;
      if (timeoutID) {
        clearTimeout(timeoutID);
      }
    }
  };

  const startPinAnim = (step = 0, reverse = false) => {
    setPinAnimStep(step);
    if (step < 9 && !reverse) {
      setTimeout(() => {
        startPinAnim(step + 1);
      }, 30);
    } else if (step > 6 && step < 10) {
      setTimeout(() => {
        startPinAnim(step - 1, true);
      }, 30);
    } else {
      setTimeout(() => {
        confirmPosition();
      }, 250);
    }
  };

  const getFeat = (_id, _layer) => {
    let _value = false;
    let nlayers = _layer.getSource().getFeatures();
    for (var i = 0; i < nlayers.length; i++) {
      if (String(nlayers[i].get("id")) === String(_id)) {
        _value = nlayers[i];
        break;
      }
    }
    return _value;
  };

  const beginPosition = (_new) => {
    openBox2(false);
    setBoard(100);
    arrow_layer.setVisible(false);
    if (keyRaster.type === "point" && !isEditor && _new) {
      let exist_x = getFeat("pin_" + keyRaster.feature.get("id"), points_layer);

      if (exist_x) {
        points_layer.getSource().removeFeature(exist_x);
      } else {
        keyRaster.newX = true;
      }

      createMarker(
        {
          COORDS: keyRaster.coords,
          PUNTOS: keyRaster.feature.get("id"),
          OBSER: "",
          SEC: keyRaster.feature.get("point"),
        },
        "empty",
        points_layer,
        false,
        writeRaster
      );
    }
    //console.log(keyRaster);
    mapRef.current
      .getView()
      .animate({ center: keyRaster.coords, duration: 500, zoom: maxZoom });
  };

  const sortMaps = () =>
    [...staticMaps]
      .sort((a, b) => (a.NOM < b.NOM ? -1 : a.NOM > b.NOM ? 1 : 0))
      .map((e) => {
        return {
          value: e.ID,
          label: `${e.NOM} (${e.TOTAL})`,
        };
      });

  const formatLang = (text) =>
    asianFormat.includes(currLang)
      ? `${text}${strLang("point")}`
      : `${strLang("point")} ${text}`;

  const pointEditor = async (findMap = {}) => {
    setOpen({ status: "loading" });
    try {
      let numbersList = [];

      const mapPointSection = await sendPostServices({
        type: "mappoint",
        code: findMap.value ?? keyRaster.feature.get("map"),
      });

      let lastPoint = mapPointSection.points[0].SEC;
      let tempSections = [...mapPointSection.sections];

      for (let a = 1; a <= lastPoint; a++) {
        numbersList.push({ value: a, label: a });
      }

      if (
        keyRaster.type === "flag" ||
        (findMap.value &&
          findMap.value !== Number(keyRaster.feature.get("map")))
      ) {
        numbersList.push({ value: lastPoint + 1, label: lastPoint + 1 });
      }

      setOpen({
        status: "editPoint",
        title:
          keyRaster.type === "flag"
            ? strLang("newNumber")
            : formatLang(keyRaster.feature.get("point")),
        mapsList: sortMaps(),
        numbersList,
        newMap: findMap.value
          ? findMap
          : {
              value: Number(keyRaster.feature.get("map")),
              label: allMaps.filter(
                (e) => e.ID === Number(keyRaster.feature.get("map"))
              )[0]?.NOM,
            },
        newPoint:
          keyRaster.type === "flag" ||
          (findMap.value &&
            findMap.value !== Number(keyRaster.feature.get("map")))
            ? { value: lastPoint + 1, label: lastPoint + 1 }
            : {
                value: Number(keyRaster.feature.get("point")),
                label: Number(keyRaster.feature.get("point")),
              },
        colorValue: open.colorValue ?? {
          value: PPColor,
          label: groupsColors.filter((e) => e.value === PPColor)[0]?.label,
        },
        groupValue: {
          value:
            tempSections.filter((e) => e.ID === keyRaster.section)[0]?.ID ?? 0,
          label:
            tempSections.filter((e) => e.ID === keyRaster.section)[0]?.NAME ??
            strLang("withoutGroup"),
        },
        groupsList: [
          { value: 0, label: strLang("withoutGroup") },
          ...tempSections.map((e) => {
            return { value: e.ID, label: e.NAME };
          }),
        ],
      });
    } catch (error) {
      console.log("pointEditor error: ", error);
      closeMsg();
    }
  };

  const beginRaster = (event) => {
    keyRaster.active = true;
    if (event.touches) {
      keyRaster.x = event.touches[0].clientX;
      keyRaster.y = event.touches[0].clientY;
    } else {
      keyRaster.x = event.pageX;
      keyRaster.y = event.pageY;
    }
  };

  const continueRaster = (event) => {
    if (keyRaster.active) {
      let cc = [0, 0];
      if (event.touches) {
        cc = [event.touches[0].clientX, event.touches[0].clientY];
      } else {
        cc = [event.pageX, event.pageY];
      }

      if (Number(mainView.getRotation()) === 0) {
        keyRaster.nCoords = [
          keyRaster.coords[0] - (cc[0] - keyRaster.x),
          keyRaster.coords[1] + (cc[1] - keyRaster.y),
        ];
      } else {
        let deltaX = cc[0] - keyRaster.x;
        let deltaY = cc[1] - keyRaster.y;
        let dist = Math.sqrt(Math.pow(deltaX, 2) + Math.pow(deltaY, 2));
        let ang = mainView.getRotation() - Math.atan2(deltaY, deltaX);
        let mx = Math.round(dist * Math.sin(ang) * 100) / 100;
        let my = Math.round(dist * Math.cos(ang) * 100) / 100;
        keyRaster.nCoords = [
          keyRaster.coords[0] - my,
          keyRaster.coords[1] - mx,
        ];
      }

      keyRaster.feature.getGeometry().setCoordinates(keyRaster.nCoords);
      mapRef.current.getView().setCenter(keyRaster.nCoords);
    }
  };

  const finishRaster = () => {
    keyRaster.active = false;
    keyRaster.coords = keyRaster.nCoords;
  };

  const confirmPosition = () => {
    setBoard(0);
    let code = keyRaster.id;

    if (!isEditor) {
      setPinAnimStep(0);
      let tempRaster = {
        coords: keyRaster.coords,
        id: keyRaster.feature.get("id").split("_")[1],
        point: keyRaster.feature.get("point"),
      };

      if (keyRaster.feature.get("group") === "empty") {
        points_layer.getSource().removeFeature(keyRaster.feature);
      }

      let exist_x = getFeat("pin_" + tempRaster.id, points_layer);

      if (exist_x) {
        points_layer.getSource().removeFeature(exist_x);
      }

      createMarker(
        {
          COORDS: tempRaster.coords,
          PUNTOS: tempRaster.id,
          OBSER: "",
          SEC: tempRaster.point,
        },
        "pin",
        points_layer,
        false,
        writeRaster
      );
      code = "pin_" + tempRaster.id;
    } else {
      keyRaster.origin = keyRaster.coords = keyRaster.nCoords;
    }
    updatePointCoords(code);
  };

  const updatePointCoords = async (code) => {
    var coords2;
    if (keyRaster.nCoords[0] === "del") {
      coords2 = keyRaster.nCoords;
    } else {
      coords2 = transform(keyRaster.nCoords, "EPSG:3857", "EPSG:4326");
    }
    updateCheck("pin", {
      code,
      ter: keyRaster.feature.get("map"),
      lat: coords2[0],
      lon: coords2[1],
      delete: false,
    });
  };

  const resetPosition = () => {
    setPinAnimStep(0);
    keyRaster.feature.getGeometry().setCoordinates(keyRaster.origin);
    keyRaster.coords = keyRaster.origin;
    mapRef.current
      .getView()
      .animate({ center: keyRaster.origin, duration: 500 });

    if (keyRaster.feature.get("group") === "empty") {
      points_layer.getSource().removeFeature(keyRaster.feature);
    }
    setBoard(0);
    clearRaster();
  };

  const clearRaster = () => {
    keyRaster = { ...defRaster };
    setBoard(0);
  };

  const deletePosition = () => {
    openBox2(false);
    setOpen({ status: "removePin" });
  };

  const updatePosition = () => {
    closeMsg();
    let _pin = getFeat("pin_" + keyRaster.id, points_layer);
    if (_pin) {
      keyRaster["coords"] = keyRaster.origin = _pin
        .getGeometry()
        .getCoordinates();
      let coords2 = transform(
        _pin.getGeometry().getCoordinates(),
        "EPSG:3857",
        "EPSG:4326"
      );
      updateCheck("pin", {
        code: keyRaster.id,
        ter: keyRaster.feature.get("map"),
        lat: coords2[0],
        lon: coords2[1],
        delete: true,
      });
    }
  };

  // const filterPoint = (data) => {
  //   setSectionId({ ...data });
  //   points_layer
  //     .getSource()
  //     .getFeatures()
  //     .forEach((c) => {
  //       if (
  //         Number(data.value) === -1 ||
  //         Number(c.get("section")) === allSections[data.value]?.ID
  //       ) {
  //         c.setStyle(
  //           newStyle(
  //             c.get("point"),
  //             checkAllDone(c.get("id"), allAddress, c.get("color")[0])
  //           )
  //         );
  //       } else {
  //         c.setStyle(new Style({}));
  //       }
  //     });
  //   if (mainBoxList) {
  //     openBox2("all", data.value);
  //   }
  // };

  const goToNavigate = (url) => {
    closeMsg();
    window.open(
      mapsUrl[url].replace(
        "{coords}",
        transform(keyRaster.coords, "EPSG:3857", "EPSG:4326")
          .reverse()
          .join(",")
      )
    );
  };

  const activateEdition = (value = false, update = false) => {
    if (Number(terId) > 0) {
      drawInteraction.setActive(value);
      areaInteraction.setActive(!value);
      layersInteraction.setActive(!value);
      if (update) {
        staticBoundary = { ...staticBoundary, createActive: value };
        setBoundaryInfo({ ...staticBoundary });
      }
    }
    if (mainBoxList) {
      openBox2(false);
    }
  };

  // const changeColor = () => {
  //   if (areaRaster.newColor) {
  //     let _style = new Style({
  //       fill: new Fill({
  //         color: `rgba(${areaRaster.newColor}, 0.05)`,
  //         weight: 1,
  //       }),
  //       stroke: new Stroke({
  //         color: `rgba(${areaRaster.newColor}, 0.5)`,
  //         width: 3,
  //       }),
  //     });
  //     areaRaster.feature.setStyle(_style);
  //     areaRaster.feature.set("color", areaRaster.newColor);
  //   }
  // };

  const closeMsg = () => setOpen({ status: false });
  const closeMsg2 = () => setOpen2({ status: false });

  const activeCenter = () => {
    setActiveLook(activeLook === 1 ? 2 : 1);
    infoRN.active = activeOrientation = activeLook === 1 ? true : false;
    clearTimeout(orientationCounter);
    if (activeLook === 1) {
      mapRef.current.getView().animate({
        center: fromLonLat([
          props.mainCoords.longitude,
          props.mainCoords.latitude,
        ]),
        duration: 500,
        zoom: maxZoom,
      });
    }
  };

  const addAddressModal = (index, deleteItem) => {
    if (deleteItem) {
      let tempList = open.addressList;
      tempList.splice(index, 1);
      setOpen({ ...open, addressList: tempList });
    } else {
      setOpen2({
        status: "newAddress",
        index,
        name: index > -1 ? open.addressList[index].name : "",
        notes: index > -1 ? open.addressList[index].notes : "",
      });
    }
  };

  const preparePDF = () => {
    setOpen({ status: "loading" });
    mapRef.current.getView().fit(area_layer.getSource().getExtent(), {
      padding: [0, 0, 0, 0],
    });
    createPDFMap({
      title,
      map: mapRef.current,
      theAddress: allAddress,
      format: "letter",
      resolution: 150,
      callback: closeMsg,
    });
  };

  const updateData = (data, second) => {
    if (second) {
      setOpen2({ ...open2, ...data });
    } else {
      setOpen({ ...open, ...data });
    }
  };

  const restoreRotation = () => {
    mainView.animate({
      rotation: 0,
      duration: 500,
    });
  };

  const handleView = (type) => {
    switch (type) {
      case "avatars":
        avatars_layer.setVisible(!viewList[type]);
        break;
      case "points":
        points_layer.setVisible(!viewList[type]);
        break;
      case "events":
        events_layer.setVisible(!viewList[type]);
        break;
      default: // "group":
        writePoints({ active: !viewList[type] });
        break;
    }
    setViewList({ ...viewList, [type]: !viewList[type] });
  };

  const activeLimitsView = () => {
    const active = !boundaryInfo.active;
    writeLimits({
      active,
      area_layer,
      allMaps: staticMaps,
      terId,
      satColor: mapType === "Aerial",
    });
    staticBoundary = { ...staticBoundary, active, data: false };
    setBoundaryInfo({ ...staticBoundary });
    if (isEditor) {
      areaInteraction.setActive(active);
      layersInteraction.setActive(active);
    } else {
      localStorage.setItem("activeBoundary", active.toString());
    }
  };

  const viewButtonsList = [
    {
      Container: MiniButton,
      active: true,
      image: { src: avatarImages["ani" + userAvatar].svg, alt: "avatar" },
      onClick: () => handleView("avatars"),
      color: colorsList.white,
      style: { opacity: viewList.avatars ? 1 : 0.5 },
    },
    {
      Container: MiniButton,
      active: viewList.eventView,
      Icon: PriorityHighIcon,
      iconColor: colorsList.orange,
      iconSize: 20,
      onClick: () => handleView("events"),
      color: colorsList.white,
      style: { opacity: viewList.events ? 1 : 0.5 },
    },
    isEditor
      ? {
          Container: MiniButton,
          active: true,
          Icon: CircleIcon,
          iconColor: colorsList.red,
          iconSize: 20,
          onClick: () => handleView("points"),
          color: colorsList.white,
          style: { opacity: viewList.points ? 1 : 0.5 },
        }
      : {
          Container: MiniButton,
          active: viewList.hasGroup && viewList.groupId,
          svg: viewList.groupId,
          iconSize: 20,
          onClick: () => handleView("group"),
          color: colorsList.white,
          style: { opacity: viewList.group ? 1 : 0.5 },
        },
  ];

  const menuList = [
    {
      Container: MiniButton,
      active: true,
      Icon: VisibilityIcon,
      iconColor: colorsList.blue,
      onClick: () => {
        setViewList({ ...viewList, active: !viewList.active });
      },
      color: colorsList.white,
      iconSize: mapButtonSize,
    },
    {
      Container: MiniButton,
      active: true,
      Icon: RoomIcon,
      iconColor: colorsList.red,
      onClick: () => openBox2(dim.main.includes(70) ? false : "all"),
      color: colorsList.white,
      iconSize: mapButtonSize,
    },
    {
      Container: MiniButton,
      active: viewList.eventView,
      Icon: PriorityHighIcon,
      iconColor: colorsList.orange,
      onClick: () => setOpen({ status: "eventsList" }),
      color: colorsList.white,
      iconSize: mapButtonSize,
    },
    {
      Container: MiniButton,
      active: true,
      Icon: MapIcon,
      iconColor: screensList.territories.color,
      iconSize: mapButtonSize,
      onClick: () => setOpen({ status: "territoriesList", search: "" }),
      color: colorsList.white,
    },
    {
      Container: MiniButton,
      active: terId > 0 && (isEditor || allSections.length > 0),
      Icon: WidgetsIcon,
      iconColor: colorsList.blue,
      onClick: () =>
        setOpen({
          status: "groupsList",
          id: sectionId.value,
          text: sectionId.value === -1 ? "" : allSections[sectionId.value].NAME,
        }),
      color: colorsList.white,
      style: { opacity: sectionId.value > -1 ? 1 : 0.5 },
    },
    {
      Container: LimitButton,
      active: terId !== "all",
      Icon: PolylineIcon,
      onClick: activeLimitsView,
      deleteClick: () => {
        startMap({
          id: staticBoundary.data.id,
          name: staticBoundary.data.name,
        });
        setOpen({
          status: "deleteArea",
          feature: areaRaster.feature,
        });
      },
      drawClick: () => activateEdition(!boundaryInfo.createActive, true),
      iconColor: colorsList.purple,
      color: colorsList.white,
      boundaryInfo,
      style: { opacity: boundaryInfo.active ? 1 : 0.5 },
    },
    {
      Container: MiniButton,
      active: isEditor && terId > 0,
      Icon: PictureAsPdfIcon,
      onClick: () => setOpen({ status: "pdf" }),
      color: colorsList.red,
    },
  ];

  const buttonsList = [
    {
      Container: MiniButton,
      active: !isEditor && activeLook > 0,
      Icon: GpsFixedIcon,
      iconColor: activeLook === 1 ? colorsList.darkGrey : colorsList.blue,
      onClick: activeCenter,
      color: "transparent",
      iconSize: 65,
      style: {
        position: "absolute",
        opacity: activeLook === 1 ? 0.7 : 1,
        top: 15,
        right: 100,
        zIndex: 100,
      },
    },
    {
      Container: Compass,
      active: true,
      restoreRotation,
      compassRef,
      mainView,
    },
    {
      Container: MapButton,
      active: true,
      image: {
        src: mapType === "OSM" ? satellitalImg : streetsImg,
        alt: mapType === "OSM" ? "satellitalImg" : "streetsImg",
      },
      onClick: () => changeTile(mapType === "OSM" ? "Aerial" : "OSM"),
      mapButtonSize,
      mapType,
    },
  ];

  const buttonsMenu = [
    {
      Icon: NearMeIcon,
      title: strLang("go"),
      active: pointId.id !== -1,
      color: colorsList.orange,
      onClick: () => setOpen({ status: "goRoute" }),
    },
    {
      Icon: LocationOnIcon,
      title: strLang("relocate"),
      active: pointId.id !== -1,
      onClick: () => beginPosition(true),
    },
    {
      Icon: AddIcon,
      title: strLang("add"),
      active: pointId.id !== -1,
      color: colorsList.darkGreen,
      onClick: () => setOpen({ status: "addAddress", name: "", obser: "" }),
    },
    {
      Icon: DeleteIcon,
      title: strLang("deletePin"),
      active: !isEditor && pointId.id === "delete",
      color: colorsList.red,
      onClick: deletePosition,
    },
    {
      Icon: PushPinIcon,
      title: strLang("pin"),
      active: isEditor && pointId.id === "delete",
      color: colorsList.red,
      onClick: () => setOpen({ status: "updatePin" }),
    },
    {
      Icon: EditIcon,
      title: strLang("edit"),
      active: isEditor && pointId.id !== -1,
      onClick: () => pointEditor(),
    },
    {
      Icon: SearchIcon,
      title: strLang("search"),
      active: pointId.id === -1,
      onClick: () => setOpen({ status: "addressesList", search: "" }),
    },
    {
      Icon: CleaningServicesIcon,
      title: strLang("clean"),
      active: isEditor && terId > 0 && pointId.id === -1,
      color: colorsList.darkGreen,
      onClick: () => setOpen({ status: "cleanAll" }),
    },
  ];

  const closeParams = (data = {}) => {
    const {
      label = strLang("cancel"),
      width = 70,
      color = colorsList.darkGrey,
      extraFunc = () => {},
    } = data;
    return {
      label,
      func: () => {
        extraFunc();
        closeMsg();
      },
      width,
      color,
    };
  };

  const msgType = {
    goRoute: {
      title: strLang("wantRoute"),
      buttons: [
        {
          label: "Google Maps",
          func: () => goToNavigate("google"),
          width: 90,
        },
        {
          label: "Waze",
          func: () => goToNavigate("waze"),
          width: 90,
          color: colorsList.green,
        },
        closeParams({ width: 90 }),
      ],
    },
    pdf: {
      title: strLang("exportPDF"),
      buttons: [
        {
          label: strLang("export"),
          func: preparePDF,
        },
        closeParams(),
      ],
    },
    deleteArea: {
      title: strLang("deleteArea"),
      label: boundaryInfo.data.name,
      buttons: [
        {
          label: strLang("delete"),
          func: () => saveLimit(open.feature),
          color: colorsList.red,
        },
        closeParams(),
      ],
    },
    askSaveLimit: {
      title: !!open.feature
        ? strLang("askCreateArea")
        : strLang("askUpdateArea"),
      label: !!open.feature ? title : boundaryInfo.data.name,
      buttons: [
        {
          label: !!open.feature ? strLang("create") : strLang("update"),
          func: () => saveLimit(false, open.feature),
          color: colorsList.green,
        },
        closeParams({
          extraFunc: !!open.feature
            ? () => area_layer.getSource().removeFeature(open.feature)
            : () => {
                writeLimits({
                  active: staticBoundary.active,
                  area_layer,
                  allMaps: staticMaps,
                  terId,
                  satColor: mapType === "Aerial",
                });
                areaRaster = false;
              },
        }),
      ],
    },
    userWindow: {
      title: open?.data?.NOM,
      inputList: [
        {
          label: strLang("notes"),
          value: open?.notes,
          style: { width: 300 },
          textArea: true,
          change: (e) => updateData({ notes: e.target.value }),
        },
      ],
      buttons: [
        {
          label: strLang("save"),
          func: () => {
            const { index, data, notes } = open;
            // if (notes.trim() !== "") {
            updateCheck("NOTAS", {
              index,
              data,
              value: notes.trim(),
            });
            // } else {
            //   openMainMsg({ label: strLang("addObserv") });
            // }
          },
          color: colorsList.red,
        },
        closeParams(),
      ],
    },
    editorWindow: {
      title: open?.data?.NOM,
      inputList: [
        {
          label: strLang("name"),
          value: open?.name,
          style: { width: 300 },
          change: (e) => updateData({ name: e.target.value }),
        },
        {
          label: strLang("observations"),
          value: open?.obser,
          style: { width: 300 },
          // textArea: true,
          change: (e) => updateData({ obser: e.target.value }),
        },
        {
          label: strLang("notes"),
          value: open?.notes,
          style: { width: 300, height: 200 },
          textArea: true,
          change: (e) => updateData({ notes: e.target.value }),
        },
      ],
      buttons: [
        {
          label: strLang("save"),
          func: () => {
            const { index, data, name, obser, notes } = open;
            if (name.trim() !== "") {
              updateCheck("UPDATE", {
                index,
                id: data.ID,
                name: name.trim(),
                obs: obser.trim(),
                notes: notes.trim(),
              });
            } else {
              openMainMsg({ label: strLang("addName") });
            }
          },
        },
        {
          label: strLang("delete"),
          func: () =>
            openMainMsg(false, {
              title: strLang("wantDeleteAddress"),
              label: open?.data?.NOM,
              buttons: [
                {
                  label: strLang("delete"),
                  func: () => {
                    const { index, data } = open;
                    updateCheck("DELETE", { index, data, value: data.ID });
                    closeMainMsg();
                  },
                  color: colorsList.red,
                },
              ],
            }),
          color: colorsList.red,
        },
        closeParams(),
      ],
    },
    updatePin: {
      title: strLang("wantUpdate"),
      buttons: [
        {
          label: strLang("update"),
          func: updatePosition,
          color: colorsList.green,
        },
        {
          label: strLang("delete"),
          func: deletePosition,
          color: colorsList.red,
        },
        closeParams(),
      ],
    },
    removePin: {
      title: strLang("askRemovePin"),
      buttons: [
        {
          label: strLang("delete"),
          func: () => {
            const exist_x = getFeat(`pin_${keyRaster.id}`, points_layer);
            if (exist_x) {
              writeRaster(exist_x);
              keyRaster.nCoords = ["del", "del"];
              updatePointCoords(keyRaster.id);
            }
            closeMsg();
          },
          color: colorsList.red,
        },
        closeParams(),
      ],
    },
    editPoint: {
      title: open?.title,
      inputList: [
        {
          label: strLang("territory"),
          value: open.newMap,
          select: open.mapsList,
          change: (e) => pointEditor(e),
          style: { width: "auto" },
        },
        {
          label: strLang("number"),
          value: open.newPoint,
          select: open.numbersList,
          change: (newPoint) => updateData({ newPoint }),
          style: { width: "auto" },
        },
        {
          label: strLang("color"),
          value: open.colorValue,
          select: groupsColors.map((e) => {
            return { ...e, color: e.value };
          }),
          change: (colorValue) => updateData({ colorValue }),
          style: { width: "auto" },
        },
        {
          label: strLang("group"),
          value: open.groupValue,
          select: open.groupsList,
          change: (groupValue) => updateData({ groupValue }),
          style: { width: "auto" },
        },
      ],
      buttons: [
        {
          label: strLang("change"),
          func: () => {
            updateCheck("UPDATEPOINT", {
              index: 0,
              code: keyRaster.feature.get("id"),
              number_old: keyRaster.feature.get("point"),
              number_new: open.newPoint.value,
              map_old: Number(keyRaster.feature.get("map")),
              map_new: open.newMap.value,
              color: open.colorValue.value,
              section: open.groupValue.value,
            });
          },
        },
        closeParams(),
      ],
    },
    addAddress: {
      title: strLang("newAddress"),
      inputList: [
        {
          label: strLang("name"),
          value: open?.name,
          style: { width: 300 },
          change: (e) => updateData({ name: e.target.value }),
        },
        {
          label: strLang("notes"),
          value: open?.obser,
          style: { width: 300, height: 200 },
          textArea: true,
          change: (e) => updateData({ obser: e.target.value }),
        },
      ],
      buttons: [
        {
          label: strLang("add"),
          func: () => {
            if (open.name.trim() !== "") {
              updateCheck("ADDR", {
                name: open.name.trim(),
                obs: open.obser.trim(),
              });
            } else {
              openMainMsg({ label: strLang("addName") });
            }
          },
        },
        closeParams(),
      ],
    },
    newEvent: {
      title: open.title,
      inputList: [
        open.mapsList && {
          label: strLang("territory"),
          value: open.map,
          select: open.mapsList,
          change: (map) => updateData({ map }),
          style: { width: "auto" },
        },
        open.cat === 1 && {
          label: strLang("placeName"),
          value: open.name,
          change: (e) => updateData({ name: e.target.value }),
          maxLength: 20,
          style: { width: "auto" },
        },
        open.cat !== 0 && {
          label: strLang("notes"),
          value: open.text,
          textArea: true,
          change: (e) => updateData({ text: e.target.value }),
          style: {
            width: "auto",
            height: open.cat === 1 ? 131 : 200,
          },
        },
      ],
      buttons: [
        {
          label: strLang(open.code ? "update" : "add"),
          func: () => {
            if (open.map === 0) {
              openMainMsg({ label: strLang("selectTerritory") });
            } else if (open.cat === 0 && open.addressList.length === 0) {
              openMainMsg({ label: strLang("enterInfo") });
            } else {
              const coords = open.code
                ? open.coords
                : transform(open.coords, "EPSG:3857", "EPSG:4326");
              openBox2(false);
              updateCheck("saveEvent", {
                ter: open.map.value,
                cat: open.cat,
                code: open.code,
                name: isEditor ? open.name : "",
                lat: coords[0],
                lon: coords[1],
                obs: open.text.trim().replace('"', "ʺ"),
                map: open.map.value,
                coords: open.coords,
                addressList: open.addressList,
                userId: user.id,
                userName: user.name.trim().replace('"', "ʺ"),
                date: getCurrentDate(true),
              });
            }
          },
        },
        open.code && {
          label: strLang("delete"),
          func: () => {
            openMainMsg(false, {
              title: strLang("askDeleteEvent"),
              buttons: [
                {
                  label: strLang("delete"),
                  func: () => {
                    updateCheck("deleteEvent", {
                      id: open.code,
                      map: open.map.value,
                      date: getCurrentDate(true),
                    });
                    closeMainMsg();
                  },
                  color: colorsList.red,
                },
              ],
            });
          },
          color: colorsList.red,
        },
        closeParams(),
      ],
    },
    newAddress: {
      title: strLang("newAddress"),
      inputList: [
        {
          label: strLang("name"),
          value: open2.name,
          change: (e) => updateData({ name: e.target.value }, true),
          style: { width: "auto" },
        },
        {
          label: strLang("notes"),
          value: open2.notes,
          textArea: true,
          change: (e) => updateData({ notes: e.target.value }, true),
          style: { width: "auto", height: 100 },
        },
      ],
      buttons: [
        {
          label: strLang("add"),
          func: () => {
            if (open2.name.trim() !== "") {
              let tempList = open.addressList;
              if (open2.index > -1) {
                tempList[open2.index].name = open2.name
                  .trim()
                  .replace('"', "˝");
                tempList[open2.index].notes = open2.notes
                  .trim()
                  .replace('"', "˝");
              } else {
                tempList.push({
                  name: open2.name.trim().replace('"', "˝"),
                  notes: open2.notes.trim().replace('"', "˝"),
                });
              }
              setOpen({ ...open, addressList: [...tempList] });
              closeMsg2();
            } else {
              openMainMsg({ label: strLang("addName") });
            }
          },
        },
        {
          label: strLang("cancel"),
          func: () => closeMsg2(),
          width: 70,
          color: colorsList.darkGrey,
        },
      ],
    },
    cleanAll: {
      title: strLang("askClean"),
      buttons: [
        {
          label: strLang("clean"),
          func: () => updateCheck("CLEAN", {}),
        },
        closeParams(),
      ],
    },
    territoriesList: {
      title: strLang("territories"),
      table: getTerList(),
      tableStyle: { minHeight: 200, maxHeight: 200 },
      inputList: [
        {
          label: strLang("search"),
          value: open?.search,
          style: { width: 300 },
          change: (e) => updateData({ search: e.target.value }),
        },
      ],
      buttons: [
        closeParams({ label: strLang("close"), color: colorsList.blue }),
      ],
    },
    addressesList: {
      title: strLang("addresses"),
      table: getAddressList(),
      tableStyle: { width: 300, minHeight: 200, maxHeight: 200 },
      tdStyle: { whiteSpace: "pre-wrap" },
      inputList: [
        {
          label: strLang("search"),
          value: open?.search,
          style: { width: 300 },
          change: (e) => updateData({ search: e.target.value }),
        },
      ],
      buttons: [
        closeParams({ label: strLang("close"), color: colorsList.blue }),
      ],
    },
    groupsList: {
      title: strLang("groups"),
      inputList: [
        {
          label: strLang("group"),
          style: { width: 300 },
          value: { value: sectionId.value, label: sectionId.label },
          select: [
            {
              value: -1,
              label: strLang("allGroups"),
            },
            ...allSections.map((e, index) => {
              return { value: index, label: e.NAME };
            }),
          ],
          change: (e) => {
            const index = Number(e.value);
            writePoints({
              active: viewList.group,
              section:
                index === -1
                  ? sectionDefault
                  : {
                      value: index,
                      label: allSections[index].NAME,
                    },
            });
            if (isEditor) {
              updateData({
                id: index,
                text: index === -1 ? "" : allSections[index].NAME,
              });
            } else {
              closeMsg();
            }
          },
        },
        isEditor && {
          label: open.id > -1 ? strLang("name") : strLang("newGroup"),
          value: open.text,
          style: { width: 300 },
          change: (e) => updateData({ text: e.target.value }),
        },
      ],
      buttons: [
        isEditor && {
          label: Number(open.id) > -1 ? strLang("update") : strLang("create"),
          func: () => {
            if (open.text.trim() === "") {
              openMainMsg({ label: strLang("addName") });
            } else {
              updateCheck("ADDSECTION", {
                map: terId,
                id: open.id > -1 ? allSections[open.id].ID : false,
                index: open.id,
                name: open.text.trim().replace('"', "˝"),
              });
            }
          },
        },
        isEditor &&
          Number(open.id) > -1 && {
            label: strLang("delete"),
            func: () =>
              openMainMsg(false, {
                title: strLang("askDeleteGroup"),
                label: sectionId.label,
                buttons: [
                  {
                    label: strLang("delete"),
                    func: () => {
                      updateCheck("ADDSECTION", {
                        map: terId,
                        kill: true,
                        id: allSections[open.id].ID,
                        index: open.id,
                        name: open.text.trim(),
                      });
                      closeMainMsg();
                    },
                    color: colorsList.red,
                  },
                ],
              }),
            color: colorsList.red,
          },
        {
          label: isEditor ? strLang("close") : strLang("cancel"),
          func: closeMsg,
          color: colorsList.darkGrey,
        },
      ],
    },
    eventsList: {
      title: strLang("events"),
      table: getEventsList(),
      tableStyle: { width: 200, height: 100 },
      buttons: [
        closeParams({ label: strLang("close"), color: colorsList.blue }),
      ],
    },
    loading: { type: "loading" },
    tileError: { type: "error", title: strLang("tileError") },
    netWorkError: { type: "error", title: strLang("netWorkError") },
    updateError: { type: "error", title: strLang("updateError") },
  };

  return {
    open,
    open2,
    closeMsg,
    closeMsg2,
    theMapBox,
    mapElement,
    dim,
    openBox2,
    board,
    beginRaster,
    continueRaster,
    finishRaster,
    pinAnimStep,
    startPinAnim,
    confirmPosition,
    resetPosition,
    title,
    sectionId,
    leyendRef,
    address,
    terId,
    buttonsList,
    getFeat,
    points_layer,
    handleClickAddr,
    focusPoint,
    updateCheck,
    closeGPS,
    goTo,
    focusLayer,
    openWindow,
    buttonsMenu,
    msgType,
    scrollMenu,
    menuList,
    viewButtonsList,
    boundaryInfo,
    openFromBoundary,
    viewList,
    updateCategory,
    addAddressModal,
  };
}
